import * as actions from "./table.actions";
import { filterType } from "../services/filtering";
import { getNextOrdering, order } from "../services/sorting";

import { CELL_TYPES } from "../index";
import {
  TableCellDate,
  TableCellEnum,
  TableCellSSN,
  TableCellMoney,
  TableCellNumber,
  TableCellPercentage,
} from "../components/Cell";
import TableCellListOfEnum from "../components/Cell/ListOfEnum";

let initialState = {};

let initTable = {
  pagination: { page: 1, take: 50 },
};

const table = (state = initialState, action) => {
  switch (action.type) {
    case actions.SET_UP_TABLE: {
      if (state[action.tableKey]) return state;

      let currentFilter = {};
      for (let i = 0; i < action.columns.length; i++) {
        if (action.columns[i].type && !action.columns[i].renderer)
          action.columns[i].renderer = getCellTemplate(
            action.columns[i].type,
            action.columns[i].enumDict,
          );

        let initFilterValue = "";
        if (action.columns[i].type === CELL_TYPES.date) initFilterValue = {};
        if (action.columns[i].type === CELL_TYPES.enum) initFilterValue = {};

        let filterMethod =
          action.columns[i].type == CELL_TYPES.text
            ? filterType.CAONTAINS
            : filterType.EUQAL;
        currentFilter[action.columns[i].key] = {
          filter: initFilterValue,
          type: filterMethod,
          cellType: action.columns[i].type,
        };
      }

      let columnOrdering = { key: "", order: order.NONE };

      if (action.order) {
        if (action.order.startsWith("-")) {
          columnOrdering.key = action.order.substring(1);
          columnOrdering.order = order.ASCENDING;
        } else {
          columnOrdering.key = action.order;
          columnOrdering.order = order.DESCENDING;
        }
      }

      return Object.assign({}, state, {
        [action.tableKey]: Object.assign({}, initTable, {
          columns: action.columns,
          selections: action.selections,
          showDetails: action.showDetails,
          allowSelection: action.allowSelection,
          currentFilter,
          columnOrdering,
        }),
      });
    }

    case actions.CHANGE_COLUMN_VISIBILITY: {
      let columns = state[action.tableKey].columns.slice();
      columns[action.index].visible = !columns[action.index].visible;

      return Object.assign({}, state, {
        [action.tableKey]: Object.assign({}, state[action.tableKey], {
          columns: columns,
        }),
      });
    }

    case actions.ORDER_BY_COLUMN: {
      return Object.assign({}, state, {
        [action.tableKey]: Object.assign({}, state[action.tableKey], {
          columnOrdering: {
            key: action.key,
            order: getNextOrdering(action.order),
          },
        }),
      });
    }

    case actions.CHANGE_PAGE: {
      return Object.assign({}, state, {
        [action.tableKey]: Object.assign({}, state[action.tableKey], {
          pagination: Object.assign({}, state[action.tableKey].pagination, {
            page: action.page,
          }),
        }),
      });
    }

    case actions.CHANGE_PAGE_SIZE: {
      return Object.assign({}, state, {
        [action.tableKey]: Object.assign({}, state[action.tableKey], {
          pagination: Object.assign({}, state[action.tableKey].pagination, {
            take: action.size,
          }),
        }),
      });
    }

    case actions.SET_SELECTIONS: {
      let selections = action.selections;

      return Object.assign({}, state, {
        [action.tableKey]: Object.assign({}, state[action.tableKey], {
          selections,
        }),
      });
    }

    case actions.SELECT_ITEM: {
      let selections = Object.assign({}, state[action.tableKey].selections);

      if (action.isSelected) selections[action.key] = true;
      else delete selections[action.key];

      return Object.assign({}, state, {
        [action.tableKey]: Object.assign({}, state[action.tableKey], {
          selections,
        }),
      });
    }

    case actions.CHANGE_FILTER_TYPE: {
      let currentFilter = Object.assign(
        {},
        state[action.tableKey].currentFilter,
      );
      currentFilter[action.key].type = action.filterType;

      return Object.assign({}, state, {
        [action.tableKey]: Object.assign({}, state[action.tableKey], {
          currentFilter,
        }),
      });
    }

    case actions.CHANGE_FILTER_VALUE: {
      let currentFilter = Object.assign(
        {},
        state[action.tableKey].currentFilter,
      );
      currentFilter[action.key].filter = action.value;

      return Object.assign({}, state, {
        [action.tableKey]: Object.assign({}, state[action.tableKey], {
          currentFilter,
        }),
      });
    }

    default:
      return state;
  }
};

export default table;

function getCellTemplate(type, enumDict) {
  //type, value, enumDict
  switch (type) {
    case CELL_TYPES.money:
      return function (value) {
        return <TableCellMoney value={value} />;
      };
    case CELL_TYPES.number:
      return function (value) {
        return <TableCellNumber value={value} />;
      };
    case CELL_TYPES.enum:
      return function (value) {
        return <TableCellEnum value={value} enumDict={enumDict} />;
      };
    case CELL_TYPES.percentage:
      return function (value) {
        return <TableCellPercentage value={value} />;
      };
    case CELL_TYPES.listOfEnum:
      return function (value) {
        return <TableCellListOfEnum value={value} enumDict={enumDict} />;
      };
    case CELL_TYPES.date:
      return function (value) {
        return <TableCellDate value={value} />;
      };
    case CELL_TYPES.ssn:
      return function (value) {
        return <TableCellSSN value={value} />;
      };

    case CELL_TYPES.text:
    default:
      return function (value) {
        return <div>{value}</div>;
      };
  }
}
/*
export const CHANGE_FILTER_TYPE = 'CHANGE_FILTER_TYPE';

export function change_filter_type(key, filterType, tableKey) {
	return dispatch => {
		dispatch({
			type: CHANGE_FILTER_TYPE,
			key,
      filterType
			tableKey
		});
	};
}

export const CHANGE_FILTER_VALUE = 'CHANGE_FILTER_VALUE';

export function change_filter_value(key, tableKey, event) {
	return dispatch => {
		dispatch({
			type: CHANGE_FILTER_VALUE,
			key,
			tableKey,
			value: event.target.value
		});
	};
}*/
